"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collect = void 0;
const collect = async (source, maxCount) => {
    if ((maxCount !== undefined) && (maxCount <= 0)) {
        return [];
    }
    const items = [];
    for await (const item of source) {
        items.push(item);
        if ((maxCount !== undefined) && (items.length >= maxCount)) {
            break;
        }
    }
    return items;
};
exports.collect = collect;
//# sourceMappingURL=collect.js.map